import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    suppliers: [],
    supplier: {},
    new_supplier: {},
    countries: [],
    validate_form: {
      name: [
        { required: true, message: 'Supplier name is required', trigger: 'blur' },
      ],
      supplier_group_id: [
        { required: true, message: 'Group field is required', trigger: 'blur' },
      ],
      email: [
        { required: true, message: 'Email is required', trigger: 'blur' },
        { type: 'email', message: 'Invalid email format', trigger: 'change' },
      ],
      phone: [
        { required: true, message: 'Phone is required', trigger: 'blur' },
      ],
      country_id: [
        { required: true, message: 'Country is required', trigger: 'blur' },
      ],
      state_id: [
        { required: true, message: 'State is required', trigger: 'blur' },
      ],
      city: [
        { required: true, message: 'City is required', trigger: 'blur' },
      ],
      address: [
        { required: true, message: 'Address is required', trigger: 'blur' },
      ],
      contact_person: [
        { required: true, message: 'Contact person is required', trigger: 'blur' },
      ],
      status: [
        { type: 'boolean', required: false },
      ],
    },
  },
  actions,
  mutations,
  getters,
};
